<template>
    <span class="sg-display-contents">
        <td class="vrm-table__cell--has-nested-table hidden-xs hidden-sm">
            <table class="vrm-table vrm-table--fixed vrm-table--compact">
                <thead>
                    <tr>
                        <td>{{ $t('dynamicess.from') }}</td>
                        <td>{{ $t('dynamicess.to') }}</td>
                        <td>{{ typeLabel }}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, idx) in rows" :key="idx">
                        <td>
                            {{ item.from.time }}
                        </td>
                        <td>
                            {{ item.to.time === '00:00' ? '23:59' : item.to.time }}
                        </td>
                        <td>{{ valueFormatter(item[valueField].value) }}</td>
                    </tr>
                </tbody>
            </table>
        </td>
        <td
            class="vrm-table__cell--has-nested-table hidden-md hidden-lg hidden-xl vrm-table__cell--single"
            colspan="2"
        >
            <table class="vrm-table vrm-table--fixed vrm-table--compact">
                <thead>
                    <tr>
                        <td>{{ $t('dynamicess.from') }}</td>
                        <td>{{ $t('dynamicess.to') }}</td>
                        <td>{{ typeLabel }}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, idx) in rows" :key="idx">
                        <td>{{ item.from.time }}</td>
                        <td>{{ item.to.time === '00:00' ? '23:59' : item.to.time }}</td>
                        <td>{{ valueFormatter(item[valueField].value) }}</td>
                    </tr>
                </tbody>
            </table>
        </td>
    </span>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component()
export default class ScheduleConfirmationTable extends Vue {
    @Prop()
    rows;

    @Prop()
    typeLabel;

    @Prop({ required: true })
    valueFormatter;

    @Prop({ required: true })
    valueField;
}
</script>
